import { useEffect, useState } from 'react';

import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';
import { getAccessToken, getRefeshToken } from '@/utils/useLocalStorage';

/** 按当前路由实时拼装，禁止模块加载期固化（否则偶发缺 dc → Global 401） */
function buildInstanceConfigUrl() {
  return `${PREFIX.vapis_v1_dc_ws(GROUPS.computing)}/instance/config`;
}

/** 按 URL 缓存，避免跨数据中心 / 工作空间串数据 */
let _configCache: { url: string; data: unknown } | null = null;

export const useInstanceConfig = () => {
  const [config, setConfig] = useState<any>(null);

  useEffect(() => {
    const url = buildInstanceConfigUrl();
    // 缺数据中心上下文时不请求，避免打到 Global scope（DataCenter: "-"）
    if (!url.includes('/dc/')) {
      console.warn('skip instance/config: missing data center in route context', url);
      return;
    }
    if (_configCache?.url === url) {
      setConfig(_configCache.data);
      return;
    }
    // 无任何登录凭据时不发受保护请求，避免 Unauthorized: access token not found
    if (!getAccessToken() && !getRefeshToken()) return;

    let cancelled = false;
    void get(url)
      .then((res) => {
        if (cancelled) return;
        _configCache = { url, data: res };
        setConfig(res);
      })
      .catch((e) => {
        console.log(e, 'get instance config error');
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return config;
};
